import { BaseComponent } from '@xplat-angular-workspace/core';

export abstract class FloatingPanelContentBaseComponent extends BaseComponent {
  constructor() {
    super();
  }
}
